import { NewSessionButton } from '@/components/layout/Navigation/NewSessionButton';
import { useIsFhirAuth } from '@/hooks/integrations/useIsFhirAuth';

/**
 * New Session action button for desktop sessions panel header.
 * Uses NewSessionButton with panel variant for consistent behavior.
 */
export function SessionsPanelAction() {
  // Epic launch UI toggles (same pattern as SideNav.tsx)
  const isFhirAuth = useIsFhirAuth();
  const canCreateNewSession = !isFhirAuth;

  if (!canCreateNewSession) {
    return null;
  }

  return <NewSessionButton variant="panel" />;
}
